const DividerLine = () => {
  return <div className="dvl-h" />;
};

export default DividerLine;
